module.exports = __webpack_public_path__ + "static/img/1015_big.e2104ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1015_big.png
// module id = HkGB
// module chunks = 1